import {Pipe} from '@angular/core';

@Pipe({
    name: 'currencyFormat'
})
export class CurrencyFormat {
    transform(value: number,
              currencySign: string = '€',
              decimalLength: number = 2,
              chunkDelimiter: string = '.',
              decimalDelimiter: string = ',',
              chunkLength: number = 3): string {

        // value /= 100;
        value = Number(value);
        if (value && !isNaN(value)) {

            const result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
            const num = value.toFixed(Math.max(0, ~~decimalLength));

            return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(result, 'g'), '$&' + chunkDelimiter) + ' ' + currencySign;
        } else {
            // return '0,00' + ' ' + currencySign;
            return '0' + ' ' + currencySign;
        }
    }
}
